const alertTypes = {
  SHOW_ALERT: 'SHOW_ALERT',
  HIDE_ALERT: 'HIDE_ALERT',
  SET_ALERT_TIMEOUT_ID: 'SET_ALERT_TIMEOUT_ID',
};

export default alertTypes;
